import { render, staticRenderFns } from "./ChatBalloon.vue?vue&type=template&id=6c586495&"
import script from "./ChatBalloon.vue?vue&type=script&lang=ts&"
export * from "./ChatBalloon.vue?vue&type=script&lang=ts&"
import style0 from "./ChatBalloon.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports